import { ContentChild, Directive, ElementRef, EventEmitter, HostBinding, HostListener, Input, Output } from "@angular/core";
import { FocusTabButton } from "../types/focus-tab-btn.model";
import { FocusTabButtonDirective } from "./focus-tab-btn.directive";

/**
 * Some elements are not focusable like divs.etc, this directive will help focus the element
 * when tabbing and perform click on enter, default tabindex is set to 0 so it won't mess with 
 * accessibility.
 */
@Directive({
    selector: '[focusTab]'
})
export class FocusTabDirective{

    @Input() tabBorderColor: string = '-webkit-focus-ring-color';
    @Input() tabBorderSize: number = 1;
    @Input() tabBorderRadius: number = 5;
    @Input() allowClickOnEnter: boolean = true;
    @Output() focusTabEnter: EventEmitter<any> = new EventEmitter();

    private _tabElements: string[] = [ 'button', 'a', 'textarea', 'input', 'select' ];
    isFocused: boolean = false;

    @HostBinding('attr.tabindex') get tabIndex(){
        return 0;
    }

    @HostBinding('style') get getStyle(){
        return {
            'outline': !this._isCustom() && this.isFocused ? `-webkit-focus-ring-color auto 1px !important`: 'none',
            'border': this._isCustom() && this.isFocused ? `${this.tabBorderSize}px solid ${this.tabBorderColor}` : 'inherit',
            'border-radius': this._isCustom() && this.isFocused ? `${this.tabBorderRadius}px` : 'inherit'
        }
    }

    @HostBinding('class') get getClass(){
        return {
            'focus-tab': true,
            'tab-focused': this.isFocused,
            'focus-tab-custom': this._isCustom() && this.isFocused
        }
    }

    @HostListener('focus', ['$event']) onFocus(event: FocusEvent): void{
        this.isFocused = true;
    }

    @HostListener('blur', ['$event']) onBlur(event: FocusEvent): void{
        this.isFocused = false;
    }

    @HostListener('keyup.enter', ['$event']) onKeyupEnter(event: KeyboardEvent){
        if( this.allowClickOnEnter ){    
            if( !this._tabElements.includes(this._el.nativeElement.tagName.toLowerCase()) ){ 
                if( this.tabBtn ){
                    this.tabBtn.click();
                }else if( this._isNgbDropdown(this._el.nativeElement) ){
                    const dropdownButton = this._getNgbdropdownButton(this._el.nativeElement);
                    dropdownButton.click();
                }
                else{
                    this._el.nativeElement.click();
                }
            }
        }else{
            this.focusTabEnter.emit();
        }
    }

    @ContentChild(FocusTabButtonDirective) tabBtn: FocusTabButton;
    
    constructor(private _el: ElementRef<HTMLElement>){
    }

    private _isNgbDropdown(el: HTMLElement){
        return el.hasAttribute('ngbdropdown');
    }

    private _getNgbdropdownButton(el: HTMLElement): HTMLElement{
        return el.children[0] as HTMLElement;
    }

    private _isCustom(): boolean{
        return this.tabBorderColor != '-webkit-focus-ring-color';
    }

}